var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83, _defs84, _defs85, _defs86, _defs87, _defs88, _defs89, _defs90, _defs91, _defs92, _defs93, _defs94, _defs95, _defs96, _defs97, _defs98, _defs99, _defs100, _defs101, _defs102, _defs103, _defs104, _defs105, _defs106, _defs107, _defs108, _defs109, _defs110, _defs111, _defs112, _defs113, _defs114, _defs115, _defs116, _defs117, _defs118, _defs119, _defs120, _defs121, _defs122, _defs123, _defs124, _defs125, _defs126, _defs127, _defs128, _defs129;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVulnsShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.2 184.5",
    style: {
      enableBackground: "new 0 0 198.2 184.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000026163910260447833770000014750531613677030553_);}\n\t.st3{clip-path:url(#SVGID_00000125579858065090791650000014511172929625647525_);}\n\t.st4{clip-path:url(#SVGID_00000136389234474380189290000002667459809824558760_);fill:#808080;}\n\t.st5{clip-path:url(#SVGID_00000180327908935105562460000006669997649412640680_);}\n\t.st6{clip-path:url(#SVGID_00000164478444424715263430000000585954276132140714_);}\n\t.st7{clip-path:url(#SVGID_00000031203410324272400870000010433723343166709391_);fill:#808080;}\n\t.st8{clip-path:url(#SVGID_00000057110257100386350470000004471677953072152472_);}\n\t.st9{clip-path:url(#SVGID_00000021084137775950293140000004284382334718002334_);}\n\t.st10{clip-path:url(#SVGID_00000181066419343879378710000005774794179887431048_);fill:#808080;}\n\t.st11{clip-path:url(#SVGID_00000122710124371265700260000016871168603211677623_);}\n\t.st12{clip-path:url(#SVGID_00000109024758700579857620000008547490782194893721_);}\n\t.st13{clip-path:url(#SVGID_00000157299056601466151450000017055332072808144318_);fill:#808080;}\n\t.st14{clip-path:url(#SVGID_00000032633484514577236950000003914597857119043484_);}\n\t.st15{clip-path:url(#SVGID_00000181779318056270859500000007287301148924873909_);}\n\t.st16{clip-path:url(#SVGID_00000149365858602122367960000003843798190594425784_);fill:#808080;}\n\t.st17{clip-path:url(#SVGID_00000145762096935509597240000012885111411706968985_);}\n\t.st18{clip-path:url(#SVGID_00000054223785006236135950000004101717528436639892_);}\n\t.st19{clip-path:url(#SVGID_00000082369672570072143030000007988491075684921732_);fill:#808080;}\n\t.st20{clip-path:url(#SVGID_00000132792631016373632430000015455892073378948256_);}\n\t.st21{clip-path:url(#SVGID_00000145039251095257125750000006003777606203053981_);}\n\t.st22{clip-path:url(#SVGID_00000033370967317322950660000016338002211241009559_);fill:#808080;}\n\t.st23{clip-path:url(#SVGID_00000165218262723318336270000010893356858471947405_);}\n\t.st24{clip-path:url(#SVGID_00000102536454242538614800000000924462768277550521_);}\n\t.st25{clip-path:url(#SVGID_00000010270901028071210370000011184293935863705248_);fill:#808080;}\n\t.st26{clip-path:url(#SVGID_00000155116247349758556170000016702301588347532691_);}\n\t.st27{clip-path:url(#SVGID_00000106854972019717291960000004424901989446197389_);}\n\t.st28{clip-path:url(#SVGID_00000046305236140548780590000001112801920241795202_);fill:#808080;}\n\t.st29{clip-path:url(#SVGID_00000016754785029134271940000012449841153258209440_);}\n\t.st30{clip-path:url(#SVGID_00000183241777894991548370000005878146377486665617_);}\n\t.st31{clip-path:url(#SVGID_00000083049930611548201190000017242803107565058742_);fill:#808080;}\n\t.st32{clip-path:url(#SVGID_00000163794043990841615220000006296950488512069791_);}\n\t.st33{clip-path:url(#SVGID_00000011006249342412974810000009941764206673881241_);}\n\t.st34{clip-path:url(#SVGID_00000091001859586257802770000002791027874046317701_);fill:#808080;}\n\t.st35{clip-path:url(#SVGID_00000016788769731279034340000015666414333959023793_);}\n\t.st36{clip-path:url(#SVGID_00000060026178173601059570000016784183361764246699_);}\n\t.st37{clip-path:url(#SVGID_00000036209365950616406940000007408463640312779445_);fill:#808080;}\n\t.st38{clip-path:url(#SVGID_00000016045330123588592110000003953130390001026461_);}\n\t.st39{clip-path:url(#SVGID_00000129181936837215704220000007495300980712924078_);}\n\t.st40{clip-path:url(#SVGID_00000141443911906546942820000003950240407155630777_);fill:#808080;}\n\t.st41{clip-path:url(#SVGID_00000172398782292402173560000013933944790363839393_);}\n\t.st42{clip-path:url(#SVGID_00000169519340614548271450000018391404025561207940_);}\n\t.st43{clip-path:url(#SVGID_00000128445542140710745870000003875173633952018616_);fill:#808080;}\n\t.st44{clip-path:url(#SVGID_00000163071841486944570650000003946952169017984180_);}\n\t.st45{clip-path:url(#SVGID_00000099622617677194133230000014663559164575414174_);}\n\t.st46{clip-path:url(#SVGID_00000141431702192526691090000015867950632844572599_);fill:#808080;}\n\t.st47{clip-path:url(#SVGID_00000002349153743939008700000010299332962817307534_);}\n\t.st48{clip-path:url(#SVGID_00000126316417198341418090000015073726134839727295_);}\n\t.st49{clip-path:url(#SVGID_00000121961275096226392440000002048819865742140823_);fill:#808080;}\n\t.st50{clip-path:url(#SVGID_00000143600053731610956840000001880116045962380935_);}\n\t.st51{clip-path:url(#SVGID_00000039812417744986786910000004659266867110029751_);}\n\t.st52{clip-path:url(#SVGID_00000112614716242337896530000001727453337729866169_);fill:#808080;}\n\t.st53{clip-path:url(#SVGID_00000151540780265392949330000017872686833677793419_);}\n\t.st54{clip-path:url(#SVGID_00000166653332762893741480000006662671096962574769_);}\n\t.st55{clip-path:url(#SVGID_00000027586869803230264850000006933801534216167560_);fill:#808080;}\n\t.st56{clip-path:url(#SVGID_00000036954297488025292940000016943714183983236029_);}\n\t.st57{clip-path:url(#SVGID_00000173122504224577287290000015544015535669500602_);}\n\t.st58{clip-path:url(#SVGID_00000075143304511594123720000006604757440135780781_);fill:#808080;}\n\t.st59{clip-path:url(#SVGID_00000096747654498609538760000009584553576030178949_);}\n\t.st60{clip-path:url(#SVGID_00000112611629481158273570000008030347361890150062_);}\n\t.st61{clip-path:url(#SVGID_00000044152561536915093190000008319790485063962768_);fill:#808080;}\n\t.st62{clip-path:url(#SVGID_00000048482372543634325390000010261354438871111308_);}\n\t.st63{clip-path:url(#SVGID_00000029740293627203143640000007755713268799954091_);}\n\t.st64{clip-path:url(#SVGID_00000135665407266103936510000007848113836138207107_);fill:#808080;}\n\t.st65{clip-path:url(#SVGID_00000180353488984368263960000002237063403764045483_);}\n\t.st66{clip-path:url(#SVGID_00000182520171870309222230000004354721533853221795_);}\n\t.st67{clip-path:url(#SVGID_00000124146099045701766660000004098422730912351417_);fill:#808080;}\n\t.st68{clip-path:url(#SVGID_00000054952770374416124640000004918238107691280555_);}\n\t.st69{clip-path:url(#SVGID_00000149347412535734356320000016065643528727130276_);}\n\t.st70{clip-path:url(#SVGID_00000056428090349886075430000014488018790125487254_);fill:#808080;}\n\t.st71{clip-path:url(#SVGID_00000170271674220474110620000011038241909037174417_);}\n\t.st72{clip-path:url(#SVGID_00000158007301064459943280000014828625159698406784_);}\n\t.st73{clip-path:url(#SVGID_00000013189399402253284590000012669400345503089837_);fill:#808080;}\n\t.st74{clip-path:url(#SVGID_00000152948455582186144690000013375650834408717442_);}\n\t.st75{clip-path:url(#SVGID_00000126291363228115604280000011001401184100529049_);}\n\t.st76{clip-path:url(#SVGID_00000077303456725219927810000010299338029847385253_);fill:#808080;}\n\t.st77{clip-path:url(#SVGID_00000051355794329527294120000010453354585278100380_);}\n\t.st78{clip-path:url(#SVGID_00000023993234300715550240000016730726807543421614_);}\n\t.st79{clip-path:url(#SVGID_00000022519463240909149100000012044699792065976249_);fill:#808080;}\n\t.st80{clip-path:url(#SVGID_00000148630755599535814580000011582801061098887857_);}\n\t.st81{clip-path:url(#SVGID_00000150801661046285863550000014697088681067262124_);}\n\t.st82{clip-path:url(#SVGID_00000114054230637617511180000014555022339198461327_);fill:#808080;}\n\t.st83{clip-path:url(#SVGID_00000041275003165571832680000016847065428575657367_);}\n\t.st84{clip-path:url(#SVGID_00000073721142394959968200000001443689874965918346_);}\n\t.st85{clip-path:url(#SVGID_00000155126627689019795780000009482351259504118203_);fill:#808080;}\n\t.st86{clip-path:url(#SVGID_00000017493665886755508790000009123781794900781198_);}\n\t.st87{clip-path:url(#SVGID_00000083786767268685124150000015561299666518157195_);}\n\t.st88{clip-path:url(#SVGID_00000163791747660326920330000006721448505954985363_);fill:#808080;}\n\t.st89{clip-path:url(#SVGID_00000171721812946871553580000009812358570131330220_);}\n\t.st90{clip-path:url(#SVGID_00000085251660065562781610000016094801023570567853_);}\n\t.st91{clip-path:url(#SVGID_00000045596137801086686030000012580283089746587318_);fill:#808080;}\n\t.st92{clip-path:url(#SVGID_00000012434616266644660230000004264935670408646292_);}\n\t.st93{clip-path:url(#SVGID_00000126309327623829799410000004910519652858946708_);}\n\t.st94{clip-path:url(#SVGID_00000077323594759972325530000017570734776458429620_);fill:#808080;}\n\t.st95{clip-path:url(#SVGID_00000003827979881954470120000012070988135885014682_);}\n\t.st96{clip-path:url(#SVGID_00000021110932880523182380000001342449068055809428_);}\n\t.st97{clip-path:url(#SVGID_00000137114488047895905660000008776799358945047483_);fill:#808080;}\n\t.st98{clip-path:url(#SVGID_00000160898153180385354840000005064413746002362280_);}\n\t.st99{clip-path:url(#SVGID_00000092450884212212161780000004252742593429995453_);}\n\t.st100{clip-path:url(#SVGID_00000052083147455049989070000015132312414221848205_);fill:#808080;}\n\t.st101{clip-path:url(#SVGID_00000127741703847073988140000003419156941097915306_);}\n\t.st102{clip-path:url(#SVGID_00000164484420073724050720000007704822248745901971_);}\n\t.st103{clip-path:url(#SVGID_00000176040706151218831450000008086807231821406090_);fill:#808080;}\n\t.st104{clip-path:url(#SVGID_00000045596153744075991020000018406005324046847417_);}\n\t.st105{clip-path:url(#SVGID_00000036243185663552932630000008065070336766280111_);}\n\t.st106{clip-path:url(#SVGID_00000083800957035269817930000013282044674457583491_);fill:#808080;}\n\t.st107{clip-path:url(#SVGID_00000142166505719475864510000017138136737235146388_);}\n\t.st108{clip-path:url(#SVGID_00000002368905212180590630000016818077821139144367_);}\n\t.st109{clip-path:url(#SVGID_00000016058585783826347700000010902386176144795020_);fill:#808080;}\n\t.st110{clip-path:url(#SVGID_00000097494205563959825500000014926331494701759897_);}\n\t.st111{clip-path:url(#SVGID_00000134970732650358048080000014655988832834754238_);}\n\t.st112{clip-path:url(#SVGID_00000074432514007344687510000007425098046831756429_);fill:#808080;}\n\t.st113{clip-path:url(#SVGID_00000008139592114831170680000015718028621209504186_);}\n\t.st114{clip-path:url(#SVGID_00000060723450101803487210000014262954261632961700_);}\n\t.st115{clip-path:url(#SVGID_00000131342038094901405810000018410693230950937021_);fill:#808080;}\n\t.st116{clip-path:url(#SVGID_00000015316875313428746120000005601233636312252336_);}\n\t.st117{clip-path:url(#SVGID_00000023277638274264219830000009867453685428683408_);}\n\t\n\t\t.st118{clip-path:url(#SVGID_00000001627140746901346380000006315621590858315450_);fill:none;stroke:#808080;stroke-width:3.2748;stroke-miterlimit:10;}\n\t.st119{clip-path:url(#SVGID_00000106125120256246631290000001508328045731777703_);}\n\t.st120{clip-path:url(#SVGID_00000155117925965931839620000009217286616066007970_);}\n\t\n\t\t.st121{clip-path:url(#SVGID_00000003096909843485110360000016376102849853767102_);fill:none;stroke:#808080;stroke-width:3.2748;stroke-miterlimit:10;}\n\t.st122{clip-path:url(#SVGID_00000139978976845764240700000008927484632944628114_);}\n\t.st123{clip-path:url(#SVGID_00000011745320910880332030000008546623527420431003_);}\n\t\n\t\t.st124{clip-path:url(#SVGID_00000070821407700850661280000010178421929257264005_);fill:none;stroke:#808080;stroke-width:3.2748;stroke-miterlimit:10;}\n\t.st125{clip-path:url(#SVGID_00000111881497420904387260000012269318831188538298_);}\n\t.st126{clip-path:url(#SVGID_00000029036739267894534570000003355180688221597352_);}\n\t\n\t\t.st127{clip-path:url(#SVGID_00000140000355518599444200000017596568404471639446_);fill:none;stroke:#808080;stroke-width:3.2748;stroke-miterlimit:10.0002;}\n\t.st128{clip-path:url(#SVGID_00000076597873543539526960000015124422410342181540_);}\n\t.st129{clip-path:url(#SVGID_00000099650526130526947240000005452630208429123200_);}\n\t.st130{opacity:0.58;clip-path:url(#SVGID_00000023997940566731313450000010559749885542348190_);fill:#808080;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 197,
    height: 184,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMUAAAC4CAYAAABThCjvAAAACXBIWXMAAAsSAAALEgHS3X78AAAg AElEQVR4nO2da3LryK6lQfrMqX/0nGowPaf6UWO6tcWO4zB94c9rASAlW/LeQoRCFB+ZSAALj8yU FE960pM+0vJT5fHXP39fxfv/+z//d7sdN0/6nejHgAIgUHx3Y1EgeD/3BMmTdnpoUDRAWMR5N55N HBMET4A86ZUeFhQJEMro87sDy07K+Ddx/OH+JzD+XHo4UJjoQBCo8zGIFHy/pM8qmjzB8QfSQ4Gi iA4KDOpzRSpCqM+fwPEExp9FDwMKAYhs6CvOLTjH+0kVABQgePwExh9EDwGKAhDqtRZgCbRDr6/S pssQJE9g/CF0d1AMAbHivUqpFLlIQUA4gMQTGH8O3RUUA0AQDASFixSKGCkUGPj+BMYfSP95gCEr QKw4rsARB8DN+y40+Ldza0qxIl1fzCLgk34julukQJRQEYJgIFDiCv5VxLik14bjT1HjGS1+X7pL pGjSpnUAiq6odrQkjx9vbeb0aG/7F/rZ8OwTEL8xrXcc2qSeUADhc2ptQa05RDJq9qkAyHMfeL12 Q+KTHpcepaZQBqkMNj/j9jMRCATBhmNO716Es7gcjEhP+sH07d7uzcNmI1WAeDGeOmDYXHdgcRwA hapF2N5eS/xCnaFqjGdt8RvSPSNFVWC7dQhOj2YwqGih0i01Y7UgtVpN6vVpVuqvf/6+SgjfAarv TPV+Bydxz0jBKPGS3hVAwnh0rjeQurUPyoGzUb+inpEidUbhrn84f9a4Bt87qc5X10Z8q/M/DSj3 AMWewjA9ejGpUyRPHsI4aahRRIrJjBZB5oARBTAUOQCpiPRKR4xp8N0Tpetrp7TVOVXr/ShgfCso ECUW1BCLiBbLEBCV956sf7CQD9MH+1KRiVR5UhrSJ4OaGFMBiCp9DPNMRRNgq88xHcsj0L2nZFkE L8Z7h9h+oYxVLbZ190V676aEXxDJXsx91TOT+mnnpa0HxCJoCDmqHQGKtyMv52hULUheH5ruVWhL AzAei97lqJGr/nK/lzfDULxsUPIF1y5FJHBEPlWE47TxEVITGHFwn9jRMVT3nR3H3eiekSKK8E6l VWlTl95MoomKFCpaqEgxfbkpZ+VhP4zfedgDO4xVvXaWf7Y5ihI/ie4BClcEupQp8PkWL+6GZV+q 9ngRhnQk3Zg8d8awHCCO8HEkDXT3Kj1+GsdPSKHuvaI9KQIDRW0Fik/F3JsSpumK4mV3HPuqduZj EW1V4yAPGZRqd+6RlEOBg8CWkUjwV51fwPNieD/K/8PQvdKnI3ntJAd/JTW7YWY82J7jrypSz74q D302/cgA7tK+s4W1igzkeRU8/7gU6hH2Pu00EV5l4EfJPeeMcoPxMWJUY2E7L82U7ifPa1bOXQ1R GbLibyLDHBXV+Jxz+XHR4pFAcZa+SvC3ULyKiPtnbjzkfft1GxmHgMg7BFzNRoOvxhM/NS2a0iOB YuqtbkGTFIUGolI3Z6yO92xUK57NIMh1zP6siiprus60Rn1WY1WTGYo4IfHbAuNeNcUZY6pmqV5J zWw0sx3OSGj0blFQTf1O5vBdjdKdd3l993yVOoUZWzWNrX4NRY33RwLn3pFi6n3o2R1ANgOCyXQh 0wp6cQUOgiCSQe7HLk3aI8IlPeMih6s/VKHbTfFm6qa3FbnI6WTyrCkGtMEwnDJ2RdLgRlEDpAxn gQHvpLzdBo852Sm7pX7ymPJYtsTDRfDUGWiOAAoIk7TJGXV1v+KNz/3Y9OoRagolbFWcZkNRaV9l PMpIJrMxG4BQrYYH2mKUUODIziGPUUUJNeb8zKR+UPJSgFBRiWPNYAikVATO+/0/YVPgvUCxwfir nJTG5OqgCSg4E7OiPSrdgUKlTSHGEzDwMMbKNC5Px1YzPkzVVMqkAK+8fTc2l+rSOUxSsIeme0YK 5aXyLAu9nTKcfK0y1KqADQNOpk3dFvU8LsU3Ac4xETQ5UrDe4NgCgGD7mbdI46oMOtBnGQGK6+/3 PLeOC0pCUcJ2xkYjclONXLnlZ1VPOE+av1zE72pX/J4ZH8emima378p9MatKnxy/ldFzps2lXXyW /f0IumehvYnUoooWLExzW0thdCw81XHmjRGCx4F+utydY87v6vk8tvzuagqOM99bAUMBOLelzh+J Dh/a/knfvLt3+pRTC7WCS8MjMFwYz5SfZZTIxLn3qsA+O86K1BjVuJiORTpfpU6ZnwoQ1Tj4PooO P+072vcstFW02JJxKm+1NJ62ihQhPKgyPAeIC+4ljy4Vm5zL7blzuZ/N9FeBzwH6jMFWqdYr/eRf 9Zh4sJsTfvupWrFlnpz5rnJjjk8BSLVxNEIokFWzQC5auYKY5+gApqBw9YGrEVSNkadec7obvxsw 7rXNI5PK49WMj9pOoIzRbXvgvQSSMo7AM+wnH6sv4EwB4dqvxuOuu9dO3Sp41W8lW47nx3wnm3Q3 pkW0iEbhrh5geuFI3Vd5TJUuRWPMAWMJjNEakCAXPVxNoe7luUlEqM5No8wHPn5axLh3pHBhuIoa am/NROjqGbdtQ7V3xLsyMnSAcFGoOn8mRaui0jRqVFFEOoSfFjHuyqz4XVmlWCf4EEqvKBu625ow BUWVonTGr8510aIC/dJcZ8qpIkEYBxXCgUwciuzjuXg3Jxe6VU2RF9VczaFeqo1pQV0Bs/KYzpvT k07Spwpw03YmEYPjOho9KkfxYyLG3Zk8+EeQk/SA5DziJAVzvASMu4tc7tx3yv/T7JAZt3NSrpag U6rqjB8RMR4hUuxUKYPePW+/+IUIwlcVYbhSvZPznKpG6OoGN/t1RC6T15QIzMrLn6kxfnzE+Bbm hBCmoT6EYOmVVaQhVR5R9V8ZCflY8WzFhxu34uXTLI6hiWwrPbu+Xa1R1RZVSvpjIsaXgWLwK9hV /+5Z522n3rcCggNENcvTRQB+rlIVdY+67vjvjqeOyaVXVSr1WwHj5qAY/gJ2CGOcUuUJz4xHRR6X Eqno4MaVqTJ0V+NEAwZFKlpV5xy/7JsGraLFbwOMm4HiwM/BTxTi6EgaURHTsSkgqujQGZfzuuoa z50Zl+KRqd6KZ/N7B1qmU78NMG6yIVDMIIUxnik4VJqxCYWpexSxr83wcEtAOACo6d8OIBOayP6C seTNl2Ge5/lLksn29n5JAMs85/MXtPWQ9URcGylMdHAKqTyWo4mX5XVHipdqRdYBYgpol4PnlCOK xTLVpiJnvJUO1PiUXrqowfFMI4Yc+6NEi9OgaAAxfTk+juSzYQwrt12lSm46sSqwnewUP9WcPsen ao8j5Dx+BYZpNPwKYDxkGnWL9KkCxKRQrYgKuKSwnQW74H3Cs4sM3UvxrQylKkYZLZTBUb4T4nNb OuZrw/h532ray+8kplI8dk5li7nuvpxORYpiFXpatFYpiKsnnEeqjCy3Pd2q0fE7BYQrNN3mQ2UQ yvOTqlQr358dEfVSvYfQl0tnXcRw22uk3u4dLQ6DYgAI916BoqIqJ68AEuCPvLk9Sx0glHFMANHN wlQ6OhJRu3Yoj0omKpKw34l+puB4H8M9gXEofToICLclIgZKzpTDahbgIiJDN5uiIsG1gAhhCNNc ujPi6j33zdRDtbsJGezyWiE7pkpKpu5c7kvJPtvBBX0/RBp1Zu+TG+yRPTFn+px4+GrvTRctqmhW 8a3qgaq2iAEYpvJ03n0iY/Kbz3fTxopf53RcZCrle8/9UeNIYfYvTUPygufigDfI92cvxjZYhPOZ I6+oFDZIGZShcUybaDf35aZKVaTIHvZIauaeW4wcO8r37BGAkcE5ng1yuVu0OBopnMF0Hiw/r7yP e0W6l56FwJv8weLUU1VycfwflaOS4SLGwh9CU+M98ueS1KEam4sSXbRgu11kdjy+0r2ixZkpWaVE NUAWaCp9qAxKCSRHir2PHCH2NllbuNTJhXrFA3m/4Fo1DubsDuiTFCST8u7V7JZyAhOguHGpzy4C BsYWoo4JyOYu0WKExMFP0izmlywCg1OFaYjBM21ggc42u/TFGZsDhpMNAcG+A8dncnPyotIoJ0vF D7dXBMaZZav6DsODAillknk5Mxv1Osbvnok6Gimq9IkeOE4YL/uid+N5eqW1aFd5XRXRAm2yNnAG zgi2mRqHzznenIGSuIDZLWgq4Cvno2SwpLqAslWf83NrUVMwA7hrtDgDCkYMBYbAgBQgLsNIoQo2 ZbwL+qHBujSFfZ4BBNsIGMZXRYoN/7RKcMQgUqgISSOfGuYCva/QsQKC4+G930ltcctoMgUFle0M zAlUgYFh3vW5ARyruEd5qsobO94VKYOm53cAC3N/x5sDhpPttZFCnQs8tyVd5HGskEN+d5E+H69v XxPO1IKA9AacD8A4C5S281RPMCrkWZElvdNbVHmkM7AQ/blZLaYVqk2O13llZcy5PdYSUTxf8ZSP K5CqnP6DF23S0grAFSCy3JzTYqrFdhUfWe/q+/J0nuSlIt73/vkoOM5MySohqkI1IIgj+2Cmz5G3 SMY0DdWB42gMTvXNdt206f76TzPduuK5yjmo+9kn+1f/a1FNlEShpy5l7bIMpwOnQzfdrNL3Vzo6 tXsEFG6AqkNlVM7Q869y/DJ/lOL2DZEXKtO9FP8uNTm6VcNNVVOZNEZ1L8elzinDYD/VOoYyMCcL 5RwY8Tvb6YCijH3ycjbwSkeAcc06RRQDjSJsqnpCCTTnq3uhreb6FU8udw/BZ8V35Ql3/lRb6jz5 VWsp+VmVPlXAZZsX0S/bV+PnWFRasqGPvIeJ7efxZ36UQ97EfR3xmQ3tHWnLMqZIGZIDBJlSBvpp 5um/eZ/4+y/ex+ukKtzSC1XkPCNTN5dGVXJS3lwBIp+rot4yfG4V97moyXGolInHLpIrWTt7qqID 0z/312Yq4r2+T6PF2Uih3jOptEmlGxuLoP3zX//8nftwgJhEi/2+Ctj5PgKyixQVQHmcDcVFMJUO KUWrCMBVdnWvi26OKHcVKRidHRDouRdEmCoNq+xsgd7UfeOIcQQUEw9LRvj5UBgzzxMI5G0RBkFF uHSN/RDQgXaOEnnK9MmzYWzKmyv+VdSeeOuKsiwoqzWN5wJHocYYGAdloY6VXJSediIwviR9uoau AUIMns+CYjpSHVd9uYL6SHE55dulLV2KoQDijH9yn+LfOY9OJl2am0lNMuRZuvzaz/GaSquUk1km KdR3/OfdGY9aPa8+rwD4LpC8JaHL/0Mo3KVOTOtUatGNaXLfhFRa4vrsqDJmJQvnuUPwRP6yDHO0 yYasakCmSnwucL3Sv6QjoDia/jhPdzZyKC9p56ahFGX8VbSgBwwTko8a9REFTdsnIM+SSnfDGPuG +1xd4Bxarn+UjtzECOWnUmUFrkM1xZn0id6k8sBdyJfhDLtyq3YUOFTfrg2Oy704A6aMhIbiZKKI z6q2M1hVnVMZreKRY694d/xkhzFNK7M8sv7cIiLTorWYeerWW0Y0jRQqVFbXOWgyuIPx8gYMJbAQ Rt2163Jq8qzuU4pXxlfJ4Qw5I6IHvmC8TCEI3jAzMZXnnEQFnsvrIV2K5SLHZvSrpq3Jx5buVVHi cIZypqaovBgZWMDwBzAUU5rOi7g5fgWQQyGzGNM0PaHxTLyUms0JY0hKXhu8tANFl0qo6N9FP5W2 KJm5vpWdhNG7AtM+NoLBRYmxLRwFRR6MC8nKOywJELxXtVGBYrolge2RfypU8cNj9tMR+8nPqtka NRa1Qsx2qg2W1IcysjPjqqIMo4Qz0El24XRcgeoqOlpoUyDq3BQQIYxCCcftA3LCqj5XglNGq867 56f9hDCe7NHzMzn9UW2pfVkK1BlYjOrX0IZ2OTYlF+coOqBWuq6c12FqC22x9SKEQivv3Hl9Fkzd 5rUuQjh+K3Ip0pE2pgbGvmjY1V+UuWM+q3Yhu+L8qBEpGe2fuYOYzpJ6c7qkfMjv9KXk3tKZQtul UBQWvaXaMOa2YUcCkcovCWaGUyUIFc4d0NWYplGC41eUFV7tpaIBqXG7PVnUBfPwozyTGCUcGAKy Dzzn2s3HnDCYbGEP8XlEZ2qKSMws4rjK31e0oQQa8CAqhSJPBGkUQu/Gpj5fHZJTO+rl9utwQVLd w2gRkHHAwey0Ch2diRoLPqsXwR2NfLfkRLMj66Ks25R4iK4ptFW0yJ6IXpn5bMU8Uy+XNlH51xqv 8zRHaRIlqEzew/6PgILPqsU1ZXBHgKFkfwvnweigdO5kWG01GfM2Wrx7qytUSFJz5Jno6V+G+1dW sY8lhGFUXqKrdaLwWl1YP0pKUYpfp2C1OObqBvdSMqmi45Qqo+vac3Whqp/++/oXx/82X0w7FTHO rlOoaBGGATWluMFrVYxXMziOtxBe7+hMiwrvR7xoVTwSHPTw7IupA9vjlhS2xTn9DTw6fqfEtjpD VONRGQepcyrbGzhstJh8X/vaDYGV18nkUp9K0a6/ri8q+Mis0C08p+OjirSuplBGTeNzHlGBijJn zfed5CZGqhksOlG+VEQ8rMOzoFAK58tNvVXA2ISwXDTpIsutFH0tMCLxXs2auOcvb2mk4oeeM4RM 3RrCLeRT2YHit2qHn+kQ8mcFcCXTqdP+QCNQmF8crz7n+9SL7SgBKOEeGWCe/q2MoFLIV5EzbNKZ lM+Np9NRCH18BVVTsYyigWN1rosk7+OZ/tRNCwrzRy0hPH9l/GHuDQiIU7aRjiv0q/n8xVzPpIT5 u9FUR4sw2GujiTN+d+8kolaZA/VZ9WepBEXxz0VOyCEETVLK2JnvZoMYUULcv+Jcpdh75NJfTc4Z uKjt9HcvB+G8fo4Wzuht6nbkB9EsKBpAqBenTo8YXKeIXShqcUqBcTvBQ0e3ysPJ63cAUxn9xHnd Ghh0gF37LjqonRD289FfCJQKGQKi25/kjsMYLAedp9jyvHUIj1DxxfMBhVzSvPclzX2rPpe0hpLf /2N+aoXju6C/3E+gnxD9cV2J+56Up8xjfwGvC2Si9JBlo/ZV7c+ptSi33pRlv4lx/EIfbh2qo09g uHZK9gwgqppCIZnenVQVjlVUcX1U1EU58mpD9bCvST9niOlT1plLXXM9MUmfpmO9RbSuaodJ/x/a ypNGDiCfVrSb/7ab7F5VzExWnV0BRUF09UYFmtPFV0NVeyqvV+dvSa5OqBzdUT7UmCuwu+enunD3 TR31J/7cL3t0uyVzaK06VwJWeaAKjwyTFTickBQw1P2dApxDqOgIINT1MwbZ9aXOu4hR9XvWQ1ft dXpzulSGvYp3Z5fcEGmB8QEU+MGADIxrUibmizxW+SPpiBJVxHCRJpMCxKQPXptQ5amdd6/IRZ8K CC6VqsZbjbFLP1WbqkbodKVA7mzR1ZYf5EVgVBsCVeMVE5lU4fTLbOxSxRuLaPKj+AjhDc7QNPw7 mijSGa+6f0oOWEpuDpSZKsDzmouC1XXeW+mZx+43ZbnBdD9PG/7kfDIw3kEBtEwNkS+XMqmdjtzx WEWMKlJ1PFWKr8bbKbOqYbqUyilparBd2yo6VLuNu7Gpa67v7lwYebsIsCTj5jt/SbD7EWYn2w/A 4OxTvkkprEqXlJFcTCjcn7sMjHhJz/Kc8lhnPb1SaH7vCvf8qgxBzQyd4bfiOX9WuoymXwf4aerU jcsBTfG/GrnmsalnAzaotohIftSULDuuPPB+TxbadNOb82or7gkIJoo2K+G4a5VCF4yPfZ+pKfbx bWm81Zz7NMqt6F+Ny62hqDFMxkZbUTx3fTm7yJ87UKgx5We2dA/3UQXu+wAKFyVC1BMVINSCSzSg 2FLbF6Df9dUVY52XUoJXCnFt7O1ckmxC8KX6ifTMJrxhZSg54hC0ymgqx1aRKoY7I1b2oeQ4SS87 MFRRMDtl5XQ2Icctd1D92eP+Uv+HNgWEAoYC4GSemQNju1nYK94ZarNQ1AxZXsnlF4EWyOYFq9uu qKO8cl/O8KoJjc14PmWoLDxDGFGWhfpFEbfCr2RBm6HeOFaV5gRshnazCr2GGAuXAtwvnrw+69In hUR6ATdIbtGo0oysuEs6p/JzRgxlaMqLUVgKYM6D8jzTKI4/UuRQfdGrs89FjKPz7jna8Jn9WDmX ytFMI0Qlwy4SVTJx/FV1rgJeBoQaZ0BXn9InMhUFg8pAuBjnplhVO9ubZ7mkvpSS8zUaJSOX4jua 61nYl0K5G3jPoTpwPgudbfF+Hgd04MZDffAZN0On9HIUGO6leJ7Ywprk5fqqZh0D+7KUnnI7BIzd +6QQ64xDpUpHQEGPRuaVUDI/9NJHiIaUlbEKIUZ6RhnMxSjCeehrQcHnnFwrL16lMteAQvVTUZav ep4Rr9qASe+fdZmP8xje+VOFdjdgRTSMTpikikmnbPJ6gYdnJGOYVsaqgLeK53O7G/qcjFkpW42X z1SgCIyJY6icG8fC94ofenDHJ9/deJ0zJgCYOhGAF8iWTpayeNdvFSnUuxqkG/AH4+COxLfi3rXT GRa9inonVcDgMWeDCBbHL9dddoNSc+nsU7UduNbx4KJKHlcm5cw4pR6YLGGbNFDnQCub4XFnfwrw nVNXspREIVXRgOTC6yeDVFt0zbbdLqIc5YvpW6eMMN5vMgtWpRyVV1yQH7tZHK7KutVd9Vu8lZGq MVQzh0pGlFc0sqIu3EbQLnreij7wOvnhgglIbsW8EoqLGM5TK4+0f2YqpLzLlpTbRQv2z2iR26w8 IXlQ5/iMixKKqtSrm0qfRolqfUIZeeUsAmNaME6nY47N2RP7/NDGV/4R5C0A0p2vPDTnu5cir3QG 69IpGiH7zEa4DtIodZzPORBNjMM9p+SVgcEV350YrdQ7ZaN4rYChdJABxhpC9VlFbDWu9+MJKCbG 7ZR5FBhV+rYrbDXKpGFmAz3Cv4sWK8ZDo3ERgzwrUCmjn+TBnQdUpPhUC1kqSmSgExAqf+/kw2vU CWsH164CjlqQZTSk7N4HRyEfMWQVLj8ZYfFnj1W7eYCZL7ceUq1YupzVjUctEqn8OZMysKM8qPx8 suLvCt0uQkzWljbwVvGjdOf67eSlvmKgdlbz+r/CFggGAvMDuUihQp4ynt2AfiFf/5RTGxAoJVZg oXeuBkplXuAELsb7LBiHWktwMlrAg0rVAnxUjkXJkgan0j+XKnRgUPIMyMKlS/mzIxcxnNfO4+Ya Q7Y3t81jS8BQWzuUHj+AgiFdGYEbsDNuphyT58KsUpIXKtd54bwNwgGhSmfcAtsqAJjfL2iHfSpg TGTD6wqUJAeI3Yuq77IQEIxe3exWlm0lI5VKOVlkuVbTwNV4K/C//gBzFSlyupK9D41HIXZvY2Wn 6bkoBE0hK0BsIleshLqJd+VhabgXjHPDb7sqhV7w7KetBKn9LKvK6YS4rsbE6xNAKK+d+64AoQzT 6Yt8UG/KqWUeLqm/fKwiRaCPEgy5M4KChi8fSgyo8JqpMlQ+54SceQsxSAqZ5MJuYKxufDSKQLqY IwZlmQEl81cBuCh4mhIV7gxj8lXgSYRwjkyBlJ8JFmcv2YEQJL+MzFxGUQJDRQp38wUdqxSDebtq Lz+vBO7ShSiQ74SZwX2Bh8/8qSjhxhiQTY4Kyok4MOy0Aqz0tCrKkYcwelPyUinTBBAvAIBbm1Ck AFoBQjmtX5BBBkZlLwEZdFHpfxv665+/d6VzVoMrqhSE8uCOCfZNUKhcMVL7TsEqUkzCvioc87OV gXGma4MSdt672aNVGJ0qYEPI5IL3KopOAKHkRx4nUT3zpeyi+gVA1mm0VaZqPE97CQEC6fj3XRaq 0K4a2xlWwKgihvOWSvnMrRXoVApQKbUSSuWJMzBYqLOvnFJlypG2oxfIOMuPEULppzPAKsLu7dLg XtL70TS34s3x+8lYTaoecBaOyI86/rDtqCq0l8Rozt+c8REYyuBCPEdQqHDsDNqlLOxfeQbpLcCf AknAYDN14TkD41PYfqMMDEYK9cy1gMjjZZ+rAYTy1JVclW6c/JU+FDgCcgoBDtWmavcDuZpCNXSB kdFYCIzMQBUpQgi48oqVl1NK5thYW7hosaENtqe81JJ4U7Sla2tKZzq58Jgy2QCG7qUcQH6fppuV ESrd0IlVDuTde6c1LjpY6sg5DXXtU4SgMCL8d7UnOXkUhhxqwAYEqp1O0SrsRpGa8Re3nbJpjE6Z 07SE41byVbzlSOEmMVxuPpVVFPpWvHQAdZGrqgU/ycx83YB2cpTe23Q/sNytaO8pU/Z8Oa2KJKQc 4vY2WHeQOjBEo+hKyeQnUnuRDCxHPmUozqvuREPdDYaFI3kj0Chj8qDSOeU4nJwoI/ahQHEtIBQ4 3LnI/HVfN/jrn7+FWHs6+1P8Ko0IDCYAluz9FDhCCJLnGGGUF5QepQibiwD2irZXHFc88twinuM4 FsFrlQ5cjMGe8c4TMASM3UWLIzy4lwNCp8tPdPSPWI7QJ4XjD1tUOlWlHJPZgEz0xDk6dCFYCZ5t d/x33lClUjHgtwNxxyN5mhrkEQfCcTl5uP6VUTtwTtOm1/a+0uAn9MkzgqFqsG5mwxmAIiVYl6Nz bnvSjzII51GdIVVeLHvaai6/q8fO8E+e3HvmVUWA7tt6ZwGh9FlFCyXfu1D1fQqG9kBozynALkjm 68q7qX6yxw1hoJXBvgsTsxXkX6VROY9fhXI4fub17txuVJd0PY9tQuSBaVWAXxeJFFURSkX9M4Co Inqrw3uSnG9PjDkBKPT/KlZMp68OCORJCtPwH4J/p8QRCGF8Kv15ERFE/TSLKmBVX44XZUgqNVLR bBIpXP8TQKhMgm09FElQFIalhMC96gTEkRXViaAYqV7fmy8tVfyrcO8AUQEjjJFXKRWnYKv6ZUKs B12fKm1y9RTlN5FlVwNKR/cIUSImgi/+KTUQYjmX7opU1acTdgxy/MpIOc6uqK0mEDieVbTfjWkf D3knr0rWTldOFi6aUQ7us2qf45kAQh1TDg8DiKgixU4mYihv6r4KWn1FVBVdO1XBdIMAAAosSURB VDlDdvluVb84A6Vi3ayImkBgKkAiv7mwnaQtCojKi09AfqSfRchGyaFLP39MYU0ah+jmn47csYoo vJdUeaYQntZ5R2eoYQyimpLsilAlG8fHhE+246KFMy7nYFxbVaQLowPlUDpAyBT0kaJEHM1bi2X2 CTich6tIeRcFiiPg6IChAOI86jQ9dDTl82hb+2c+e0jfRVStosaPBkScENIrDcHh6g2Xk3desFKQ e7Et8ku+FAgUUPiskgPPHaUjBj2JPFNyToXT5S5K/GhAxJVKm/55pMp5K0+raAKGHEFUMeuAUaVI LmpUEUONpRrjEePP1yYG1YFlkn5NaovJVPaPAERcC4qdxP9vd4CoikhHLlJUBbFUiBi7ihhV1FgQ NbpxuGgaeM7RItKh/LkyMOf5K8B0UbkCwY8GRJjvLB+iYsp2Ylj5nok3nub1jpyxVko6ktMrD+vu pcyO9jfhJwqeumhAg56kTSpq/yhAxGRKdkgKEGo2R00TugWsClzuxX474Ew8optCdtPK1X2qP9X3 NaQM33nwCa/dwqtql+N7p8Ei693pVjWFM+JumjOu4MEp2CmXHozUpX9VtAscq4W9CqBdylXRIkCg 5KRk5tIqd1ytTLtU1fH0gR4pgpwGhUib1Jx/tUqsUoZOMOo+led2Hs315QzcjdEZuZpZU22EkcO1 3vRIihQ4voh2qpkn9teBoLz+sBsCD1BXT6i0R3lX5bWcN9tMG5O06pNH/q8SilX7aKYc+XI/HeOO w4yvSmNcm9UOAQeIyoFwJwK/C6EA4WzApdWRnnmlR0ivToFCTMVWOX+V5ytvNfXymwCGS9O62kJt Z4kiDyef7lfOeRypjy6tqcDQTX126Ywax1aMxwE1y2oCBKeb/PzdgXGqczEFm43f/U4QjZHKUjMW mc8qHw9hCN2XoCb1RYg+Ve2g5MH7u60ijpfAtQXHizBO9WwFthApEp+NRmZR6CaEvh143++5Vyp1 i/SpSpmYrihAVB7KpSfKA9Irqf+M677f4FKvDpTOuajxqzYmkWLquVX6pHRB/iYOUjmHRcize7ls 4kM/94oYt/h7r+w1q6nVnbIxd9N6uY+93UsTfrfET6YufenGVx1vxuDUMa+FcBLuGqNC12+IZxY8 d8QbL+J5F0lVBHRp6Ir3u9JZULh0QuWR+RoBofLagHEsQhkrBKl4ugjvk69lBdFwcntq7J0hqmdk oW8MJgyIO17WNB6CkvIMnIsCILyunBGdFJ0SAREYa3Z4TiffQofDk/nBNIbPJb3TgztAuAIuhNC7 NCegAJWGKOObkko58jHHXhWXKu1xhsPoRIeg6hYCRM1gqXMxAInqr6sfq/RYyeHba4tr0ycVKaLx ig4QKhfOz+W2d4PJRkUesse5COVd0vUzQlcORaUPnZGqsbp0g6AgHxcYpeKTYw8h02rMjBBMmVcB VgKbdhNCj3eLFteAwqVNKrVwSp6Cgu2sMJJlCIxIx0viIw4If5IqKSAcAYSrs8gjjSwK4+Jn5u8q rye4KkCoqE1e16Trfd1jxXvcExBxg5oihBE4cFC5Z0CR21wLY4nkrTYYxiW9f4Xwl9S3W712jsKl NWHSPAVAtqWc1E4VMKq+QoAgp84qUtCRbWlD6pbucX+F9m10y9knCm+nDcfOCKYee4NhLwIY9Gj5 uooUtwYFDcjJhMBw+X40oFjFPQuAoQAS4twq5KEyArU4+9JECpcyMeoz7fpWulX6FEbgHLxLDfJ9 1a9Nu3ybgFBGeYnPIfoC73oLUh61kgmjgqq5ouHvkoyThrY/T2N3QFkEAFUWMF3byVEgj13VFyqS fjudWbyrjL8DBt95rvq1aRVxOj5pnC7f75R85KXSJcrhCCCqdFPN3LiZHEbEDXy61KiTmzqvokj1 nEu570K3qCmc8o/StZ6hej57RVWEds/fggjkagZOTVF3/OWox5mqSEap2lERhM+GadOliupeAlHR XaNE3KimeDSqBMrUi8e3JtYyKvWrAFGt3UThZVXBup+jUbJdBxqVbjm+8pirNhXdFRBxBSiUcK6l W3sIpWyCoTO6s6Q8pauFRotYKq0Uf1yyPxcAxpZ0tjSyVrJQRTPrlxDtqpTXzTJ+pXM6RGdqiokn VkQPJXNvtQnMbAyrUjhneJVnvvVL/VKi+t3d6v+sp0aiapT9WPWn+lU8H31NfgXS6cWB6dvpmvTp yEBy6K2Kq9f7ChBM89cc7isldGsjZ2nihSu+ruFpfy5HjLwmE0ZmXZucsKhSUOrFRUUVvTmOb6db 1BQuDHJ6rZpxyPPsVQHGmaJq1iJPK7oIkd+/g6j8vAahPKmSr5K/S4cyGNTGySkpXeb0icfsS+mg iyR3ozPpUwhEu1cmZdRq6o4GX82FVxsB9xdThi6F+Op0Sv3gdAkItyGu+bsEplJV/0d4d69/0+t/ Qp/Lnzn+s6njzenaSOHSFEcqOux0KTxepOdeAAhugAsI1tUO2Xjim5Sg0oMqDTnadpbfgsi7QU5n I8V+nIttdfzLRAoFVJdO3YXORoowQFAei6lUFR2qxSLurVkBCJe/bsLLscj9roihcmt69jyGdtu0 +I9CGqBzCGejHQv3f9P5HBUYKf5torS0o3t8JfUwKMwX/FWOzuv0Nh0wMhDcn65XhTbTJ2cQVfrH V2fgU6NTaU7mnbKe6qTSC/us+HYpmPPyBEcFiH+NTh4iSsSN1il4nAXqijoVhiN9JjFq8DjztaV2 Jh47TiqieobXuvY/XD/jHcWfYO6UP6t2KT/ex7bYrlr7UM6KkaBySo7Xb6Fb1BQBA1uSoXNgWZCB 7d28RgGHAIVLnegNq6LuW4X/1emAaP9Tf5jyPsIPQUE9XoxuuvRaAuJev+Zxy0I7YJAZHC6qcGrP GalSwBQQLl3Z7pWz3pvOjtmsoC9wiG6KPD8TAgQPAYi4QaEdYkD0xtkw83Oq+Hb/A6eK8DCAsAB4 hND8k+lEUe/0UU0w3J2OTMt9IPOfFNWXTtSiDlMlJxhVk1AxLkqUadOfGCmupeKfrELoluQA8DD6 uGX65NKoSFsNwqyOurl0kgPRUUC80hMQ58gU9cpRTejh9HE6UkT9D0bdKvUiosZR2gXo0jVXT8Qz Styezv6a3yPq4FZ7nzgNmA02klFW30ybCDX3cUnvrF2q+e8nIL6Afid5XlNoV3tv3CLWL5yvlvmr 4tmtRFeAeILgSSO6Kn3aafC/d24lWhXeVYHmCutuxukZJZ40ppuAIubAUKvSXH8I8KWK6sBUXlU7 PAHxpEN0M1BEDYxAVFjFOd5PcpHCRYW8XeQJiCeN6aagCA2MEJGC56IBxE4OGGGiQzwB8aSjdHNQ hF/ccQBw7yRl7Aok+forPQHxpCP0JaCIetWzSrHU/WFWPx0Y4hkdnnQNfRkodhpsCegAEc7on5Hh SV9BXw6KTA1A3LlMytifYHjSTelbQUG69o/+niB40s0pIv4/TBPk3vQAdD0AAAAASUVORK5CYII=",
    transform: "matrix(0.9973 0 0 0.9973 1.6953 0.6851)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 0.5,
    className: "st0",
    width: 196,
    height: 184
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165934657430915349630000003605320343119837363_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165934657430915349630000003605320343119837363_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150803754606165454450000010328314523595941793_",
    d: "M51.3,81.8h8.1c0.1-0.5,0.2-1.1,0.4-1.6h-8.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132069417966338890770000003274902196081847743_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150803754606165454450000010328314523595941793_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132069417966338890770000003274902196081847743_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142869435376400890970000017392566910604670091_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109750728332961972810000010406911614559676564_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142869435376400890970000017392566910604670091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 50.3,
    y: 79.2,
    style: {
      clipPath: "url(#SVGID_00000109750728332961972810000010406911614559676564_)",
      fill: "#808080"
    },
    width: 10.4,
    height: 3.6
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152982740017692046460000004982080709176776833_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125597319389099952080000002740811312575602313_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152982740017692046460000004982080709176776833_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000125597319389099952080000002740811312575602313_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000157287271689707531430000014158193947297022120_",
    d: "M50.7,80.3l0.1,0.5H59c0,0.2-0.1,0.3-0.1,0.5 h-8.1l-0.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108301630458169785580000008974776206651481238_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157287271689707531430000014158193947297022120_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108301630458169785580000008974776206651481238_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111910959660649417540000008705196106287921063_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175281797458807103320000009284859467928182432_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111910959660649417540000008705196106287921063_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 79.3,
    style: {
      clipPath: "url(#SVGID_00000175281797458807103320000009284859467928182432_)",
      fill: "#808080"
    },
    width: 10.3,
    height: 3.4
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069381775817523378750000009043206067269451414_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120558062174241208440000010965555079446565796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069381775817523378750000009043206067269451414_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120558062174241208440000010965555079446565796_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000097462179655056587010000013801972305067920546_",
    d: "M169.3,81.8c0.4,2.6,2.6,4.6,5.3,4.6 c3,0,5.4-2.4,5.4-5.4s-2.4-5.4-5.4-5.4c-2.7,0-4.9,2-5.3,4.6h-9.5c0.1,0.5,0.2,1,0.4,1.6L169.3,81.8L169.3,81.8z  M174.6,77.2c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8S172.5,77.2,174.6,77.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165208519393967604060000015443191801859448456_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097462179655056587010000013801972305067920546_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165208519393967604060000015443191801859448456_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018924399687236231600000005953371201674122888_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053530702381945250320000003100556505962801577_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018924399687236231600000005953371201674122888_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 158.8,
    y: 74.6,
    style: {
      clipPath: "url(#SVGID_00000053530702381945250320000003100556505962801577_)",
      fill: "#808080"
    },
    width: 22.2,
    height: 12.8
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000177462614617559187190000003239208140264691603_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005982288716610511800000004142419616459678349_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177462614617559187190000003239208140264691603_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005982288716610511800000004142419616459678349_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147211679597247748400000000208549575416937140_",
    d: "M174.6,85.9c-2.4,0-4.4-1.8-4.8-4.1l-0.1-0.5 h-9.2c0-0.2-0.1-0.3-0.1-0.5h9.3l0.1-0.5c0.3-2.4,2.4-4.1,4.8-4.1c2.7,0,4.8,2.2,4.8,4.8 C179.5,83.7,177.3,85.9,174.6,85.9 M174.6,76.7c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3 C179,78.6,177,76.7,174.6,76.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052790413860354182000000017387761947155966873_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147211679597247748400000000208549575416937140_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052790413860354182000000017387761947155966873_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000024704457132348500190000013916034071612700554_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047026371767623533930000003890254752185779107_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024704457132348500190000013916034071612700554_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159.5,
    y: 75.2,
    style: {
      clipPath: "url(#SVGID_00000047026371767623533930000003890254752185779107_)",
      fill: "#808080"
    },
    width: 21,
    height: 11.7
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052077948357354433750000013044182636839486101_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148625151173575769430000014147119901770389640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052077948357354433750000013044182636839486101_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000148625151173575769430000014147119901770389640_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178192778911047577300000008979195515679038898_",
    d: "M45,111.3h16.5c-0.2-0.5-0.4-1-0.6-1.6H45"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018203361272271099660000016993999743095555235_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178192778911047577300000008979195515679038898_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018203361272271099660000016993999743095555235_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062182207237262017700000009646117068371565728_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147910865190178064440000002965951218770628487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062182207237262017700000009646117068371565728_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 108.7,
    style: {
      clipPath: "url(#SVGID_00000147910865190178064440000002965951218770628487_)",
      fill: "#808080"
    },
    width: 18.5,
    height: 3.6
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000064319513204926840300000002640413065181191356_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071529270424197368290000011117220012699734958_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064319513204926840300000002640413065181191356_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000071529270424197368290000011117220012699734958_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127011751722335934510000008652070483887658131_",
    d: "M44.5,109.8l0.1,0.5h16c0.1,0.2,0.1,0.3,0.2,0.5 H44.6l-0.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039850174908507346270000006193506060972638592_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127011751722335934510000008652070483887658131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039850174908507346270000006193506060972638592_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000157300980651672433320000001733669352576677567_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112593588905499576630000015037483243280461715_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157300980651672433320000001733669352576677567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 108.8,
    style: {
      clipPath: "url(#SVGID_00000112593588905499576630000015037483243280461715_)",
      fill: "#808080"
    },
    width: 18.2,
    height: 3.4
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103957477523500178420000001990395152336723365_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120539215991652798800000003316437366070356923_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103957477523500178420000001990395152336723365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120539215991652798800000003316437366070356923_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111152747053212933210000016842068762502870418_",
    d: "M175.6,111.3c0.4,3,3,5.4,6.1,5.4 c3.4,0,6.2-2.8,6.2-6.2c0-3.4-2.8-6.2-6.2-6.2c-3.1,0-5.7,2.4-6.1,5.4h-17c-0.2,0.5-0.4,1.1-0.6,1.6L175.6,111.3 L175.6,111.3z M181.7,105.9c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6S179.2,105.9,181.7,105.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044136658915376703790000008104815273751241138_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111152747053212933210000016842068762502870418_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044136658915376703790000008104815273751241138_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106111804542962472580000014609256479627877026_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170239643459155440660000018408284397313634953_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106111804542962472580000014609256479627877026_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 157.1,
    y: 103.4,
    style: {
      clipPath: "url(#SVGID_00000170239643459155440660000018408284397313634953_)",
      fill: "#808080"
    },
    width: 31.9,
    height: 14.4
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147208224037389547750000002725273636479130813_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145741804839468622180000017159551390717207462_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147208224037389547750000002725273636479130813_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145741804839468622180000017159551390717207462_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000027581249368026384260000000550348342750391947_",
    d: "M181.7,116.2c-2.8,0-5.3-2.1-5.6-4.9l-0.1-0.5 h-17.2c0.1-0.2,0.1-0.3,0.2-0.5h17.1l0.1-0.5c0.4-2.8,2.8-4.9,5.6-4.9c3.1,0,5.7,2.5,5.7,5.7 C187.4,113.7,184.8,116.2,181.7,116.2 M181.7,105.4c-2.8,0-5.2,2.3-5.2,5.1c0,2.8,2.3,5.1,5.2,5.1c2.8,0,5.2-2.3,5.2-5.1 S184.6,105.4,181.7,105.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086654627487553077450000015358885140573044671_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027581249368026384260000000550348342750391947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000086654627487553077450000015358885140573044671_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000184344243301815880000004827142808173295002_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103231410213993700340000017863644569874931347_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000184344243301815880000004827142808173295002_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 157.8,
    y: 103.9,
    style: {
      clipPath: "url(#SVGID_00000103231410213993700340000017863644569874931347_)",
      fill: "#808080"
    },
    width: 30.6,
    height: 13.3
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000030487524101237543130000011167415224608768651_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107551600699852554390000006277763358537695900_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030487524101237543130000011167415224608768651_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107551600699852554390000006277763358537695900_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062181303633592099250000017215580578790217366_",
    d: "M181.7,112.1c0.8,0,1.5-0.7,1.5-1.5 s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S180.9,112.1,181.7,112.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052816836424987335440000009682006400944596415_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062181303633592099250000017215580578790217366_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052816836424987335440000009682006400944596415_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137123794315099425740000005140385058413188494_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021100358001591969210000013654096582030859141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137123794315099425740000005140385058413188494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.2,
    y: 108,
    style: {
      clipPath: "url(#SVGID_00000021100358001591969210000013654096582030859141_)",
      fill: "#808080"
    },
    width: 5,
    height: 5
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075133738501002320630000010875376270723934379_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147927776581105685670000017554026298675163557_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075133738501002320630000010875376270723934379_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147927776581105685670000017554026298675163557_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080194238577180037200000003801074308751908009_",
    d: "M181.7,111.5c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1 c0.5,0,1,0.4,1,1S182.3,111.5,181.7,111.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168837383377647279210000011601750076200245391_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080194238577180037200000003801074308751908009_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168837383377647279210000011601750076200245391_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000097487886501735967510000012034404957717781938_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101075451435685729950000004345206418728392890_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097487886501735967510000012034404957717781938_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.7,
    y: 108.5,
    style: {
      clipPath: "url(#SVGID_00000101075451435685729950000004345206418728392890_)",
      fill: "#808080"
    },
    width: 4,
    height: 4
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116213265351958326480000008831834788883450530_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047763190362534810340000006204495790696612498_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116213265351958326480000008831834788883450530_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047763190362534810340000006204495790696612498_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152984706409097658260000009376747082911697331_",
    d: "M153.8,158.9c0.9,0,1.6-0.7,1.6-1.6 s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S153,158.9,153.8,158.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030468116956977475570000012529768039376498356_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152984706409097658260000009376747082911697331_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030468116956977475570000012529768039376498356_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036939518254045282490000012424725382547653293_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178926205542424281430000012336182300722572981_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036939518254045282490000012424725382547653293_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 151.2,
    y: 154.7,
    style: {
      clipPath: "url(#SVGID_00000178926205542424281430000012336182300722572981_)",
      fill: "#808080"
    },
    width: 5.1,
    height: 5.1
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044867916716267012550000004602582449625862043_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056390166297709459500000002347534924076591500_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044867916716267012550000004602582449625862043_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056390166297709459500000002347534924076591500_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158724346922624755210000011346426468161268140_",
    d: "M153.8,158.3c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1 c0.6,0,1,0.5,1,1C154.9,157.9,154.4,158.3,153.8,158.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109013744326564863600000010237641299349358985_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158724346922624755210000011346426468161268140_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109013744326564863600000010237641299349358985_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000078746862817002049930000015411545590216543384_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159451784290011267250000006459641759180346785_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078746862817002049930000015411545590216543384_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 151.8,
    y: 155.3,
    style: {
      clipPath: "url(#SVGID_00000159451784290011267250000006459641759180346785_)",
      fill: "#808080"
    },
    width: 4.1,
    height: 4.1
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106828314707364499730000009510294514329807258_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106128541490570295880000016920060667691065742_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106828314707364499730000009510294514329807258_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106128541490570295880000016920060667691065742_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089535798858410293610000015957930248223273405_",
    d: "M71.5,29.7h24v13.7c0.5-0.1,1-0.3,1.6-0.4V29 c0-0.4-0.3-0.8-0.8-0.8H71.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127019299681051721340000011835232669317725108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089535798858410293610000015957930248223273405_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127019299681051721340000011835232669317725108_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114762418219567936610000004551129563423127434_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008842722327230530950000007802816765307132553_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114762418219567936610000004551129563423127434_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 27.1,
    style: {
      clipPath: "url(#SVGID_00000008842722327230530950000007802816765307132553_)",
      fill: "#808080"
    },
    width: 27.6,
    height: 17.3
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047771960809669551110000011860354705674066578_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099646337166144599070000010500434962060294295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047771960809669551110000011860354705674066578_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099646337166144599070000010500434962060294295_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152979122038677611300000005848143515251023287_",
    d: "M71,28.1v0.5h25.2c0.1,0,0.3,0.1,0.3,0.3v13.6 c-0.2,0-0.3,0.1-0.5,0.1V29.1H71l-0.1,0.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018956691185847829990000008487079982886812562_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152979122038677611300000005848143515251023287_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018956691185847829990000008487079982886812562_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000087406757993137442100000015436346647277922221_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098196087429401071120000009660258854620053404_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087406757993137442100000015436346647277922221_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 27.1,
    style: {
      clipPath: "url(#SVGID_00000098196087429401071120000009660258854620053404_)",
      fill: "#808080"
    },
    width: 27.6,
    height: 16.6
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000004518432568393422080000002162128966044761534_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089571026461763884730000006816285159571071915_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004518432568393422080000002162128966044761534_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000089571026461763884730000006816285159571071915_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000113317134040687996910000017743981472198818696_",
    d: "M55.7,157.8h40.6c0.4,0,0.8-0.3,0.8-0.8v-13.9 c-0.5-0.1-1-0.3-1.6-0.4v13.5H55.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170254410496789304850000014421983598677006252_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113317134040687996910000017743981472198818696_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170254410496789304850000014421983598677006252_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000019649817858184463500000005125393593320543394_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003827719720433734080000017074822620153528999_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019649817858184463500000005125393593320543394_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 141.6,
    style: {
      clipPath: "url(#SVGID_00000003827719720433734080000017074822620153528999_)",
      fill: "#808080"
    },
    width: 43.5,
    height: 17.1
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000020358683349884428040000017363934357496329907_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054231059374239418530000005559745196369723561_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020358683349884428040000017363934357496329907_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054231059374239418530000005559745196369723561_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106110926477443600560000013871279286738000028_",
    d: "M55.1,156.3l0.1,0.4h40.9v-13.4 c0.2,0,0.3,0.1,0.5,0.1v13.5c0,0.1-0.1,0.3-0.3,0.3H55.2v0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031189217410651521580000004630784549644897688_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106110926477443600560000013871279286738000028_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000031189217410651521580000004630784549644897688_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000121252422312047243100000010041791420257762444_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177454821624166210130000014158533014798199470_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121252422312047243100000010041791420257762444_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.1,
    y: 142.3,
    style: {
      clipPath: "url(#SVGID_00000177454821624166210130000014158533014798199470_)",
      fill: "#808080"
    },
    width: 43.5,
    height: 16.4
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068666849612210360630000015640454078386113195_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039840168039615566960000012508893176129007544_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068666849612210360630000015640454078386113195_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039840168039615566960000012508893176129007544_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000162342341139883038450000000620737347064256957_",
    d: "M122,156.9c0,0.4,0.3,0.8,0.8,0.8h24.7 c0.2,3.3,3,5.9,6.4,5.9c3.5,0,6.4-2.9,6.4-6.4s-2.9-6.4-6.4-6.4c-3.1,0-5.7,2.3-6.3,5.3h-24v-13.4c-0.5,0.1-1,0.3-1.6,0.4 C122,143.1,122,156.9,122,156.9z M153.8,152.5c2.6,0,4.8,2.2,4.8,4.8s-2.2,4.8-4.8,4.8s-4.8-2.2-4.8-4.8 C149,154.6,151.2,152.5,153.8,152.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056427570509224990050000017307028663679208834_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162342341139883038450000000620737347064256957_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056427570509224990050000017307028663679208834_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000169551571265282304030000013088378058075720105_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050630862044055956130000002572505199323831187_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169551571265282304030000013088378058075720105_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 141.8,
    style: {
      clipPath: "url(#SVGID_00000050630862044055956130000002572505199323831187_)",
      fill: "#808080"
    },
    width: 40.2,
    height: 22.9
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114758393119877876910000006244927083622686624_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071521129704849717570000012125127128463527087_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114758393119877876910000006244927083622686624_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000071521129704849717570000012125127128463527087_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000126319249546011998120000005376092001468128928_",
    d: "M153.8,163.1c-3,0-5.6-2.4-5.8-5.4v-0.5h-25.2 c-0.1,0-0.3-0.1-0.3-0.3v-13.4c0.2,0,0.3-0.1,0.5-0.1v13.2h25l0.1-0.4c0.5-2.8,2.9-4.8,5.7-4.8c3.2,0,5.8,2.6,5.8,5.8 C159.7,160.5,157,163.1,153.8,163.1 M153.8,152c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3 S156.8,152,153.8,152"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149375201728676148230000006574096217013352110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126319249546011998120000005376092001468128928_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000149375201728676148230000006574096217013352110_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000076587575416338520390000003906259181966471341_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174580129804734800760000006127329304172155292_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076587575416338520390000003906259181966471341_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 142.4,
    style: {
      clipPath: "url(#SVGID_00000174580129804734800760000006127329304172155292_)",
      fill: "#808080"
    },
    width: 39.2,
    height: 21.7
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069381147904146436100000006806825555418140548_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029749044591480860730000014635254468104980894_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069381147904146436100000006806825555418140548_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029749044591480860730000014635254468104980894_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000161596043757656209450000014757276225004069517_",
    d: "M148.2,28.1h-25.5c-0.4,0-0.8,0.4-0.8,0.8v13.9 c0.5,0.1,1,0.3,1.6,0.4V29.6h24.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008106505762577197950000013081325710621729459_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161596043757656209450000014757276225004069517_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000008106505762577197950000013081325710621729459_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116953362738077446300000012643302709373738423_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165194366033288076740000010519301375226059951_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116953362738077446300000012643302709373738423_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 27.1,
    style: {
      clipPath: "url(#SVGID_00000165194366033288076740000010519301375226059951_)",
      fill: "#808080"
    },
    width: 28.4,
    height: 17.2
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000049928695163522837160000008635555719641848240_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137130527041285398970000013011713859641560730_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049928695163522837160000008635555719641848240_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137130527041285398970000013011713859641560730_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000090255192656130558100000010814870855509851817_",
    d: "M148.8,29.6l-0.1-0.4h-25.8v13.3 c-0.2,0-0.3-0.1-0.5-0.1V28.9c0-0.1,0.1-0.3,0.3-0.3h26v-0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016056307090893800090000017664848032147980709_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090255192656130558100000010814870855509851817_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016056307090893800090000017664848032147980709_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052103799014483626300000005304377974455891088_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136369230531828349620000012126107989843156656_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052103799014483626300000005304377974455891088_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 27.1,
    style: {
      clipPath: "url(#SVGID_00000136369230531828349620000012126107989843156656_)",
      fill: "#808080"
    },
    width: 28.4,
    height: 16.4
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137813779019048682270000012476831337152104844_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028323426833956159930000000901937555334934958_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137813779019048682270000012476831337152104844_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000028323426833956159930000000901937555334934958_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000932092305680338900000008182629506762506667_",
    d: "M156.5,93c0-25.8-21-46.7-46.8-46.7 S62.9,67.3,62.9,93c0,25.8,21,46.7,46.8,46.7S156.5,118.8,156.5,93 M64.9,93c0-24.7,20.1-44.9,44.9-44.9 c24.7,0,44.9,20.1,44.9,44.9c0,24.7-20.1,44.9-44.9,44.9S64.9,117.7,64.9,93"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000202239875960697990000005726031489688447664_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000932092305680338900000008182629506762506667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000202239875960697990000005726031489688447664_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096051254195049559410000010333934372142318235_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103987856436467696840000013140438683900431749_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096051254195049559410000010333934372142318235_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 45.3,
    style: {
      clipPath: "url(#SVGID_00000103987856436467696840000013140438683900431749_)",
      fill: "#808080"
    },
    width: 95.5,
    height: 95.5
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000007405958870279889750000016694729133181999527_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039846641013434018270000001753765322466914969_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007405958870279889750000016694729133181999527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039846641013434018270000001753765322466914969_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011717294133635102400000014517712453894893975_",
    d: "M109.8,139.2c-25.5,0-46.2-20.7-46.2-46.2 s20.7-46.2,46.2-46.2S156,67.5,156,93S135.3,139.2,109.8,139.2 M109.8,47.6c-25,0-45.4,20.4-45.4,45.4 s20.4,45.4,45.4,45.4S155.2,118,155.2,93S134.8,47.6,109.8,47.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030477898405936704900000002881346454115722885_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011717294133635102400000014517712453894893975_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030477898405936704900000002881346454115722885_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000180365849082212500280000017353191511800402333_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100348572282258463450000013858614404872805279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180365849082212500280000017353191511800402333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 45.8,
    style: {
      clipPath: "url(#SVGID_00000100348572282258463450000013858614404872805279_)",
      fill: "#808080"
    },
    width: 94.5,
    height: 94.4
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021827629385304458970000013374128411316304280_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005952828213315781650000007878090019592579230_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021827629385304458970000013374128411316304280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005952828213315781650000007878090019592579230_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115501403347986533580000007697569304407258268_",
    d: "M119.1,39.8l0.2-1.2c-6.4-1.1-13.2-1.1-19.7,0.1 l0.2,1.2C106.2,38.7,112.8,38.7,119.1,39.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006708343891619698030000000357826927857064119_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115501403347986533580000007697569304407258268_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006708343891619698030000000357826927857064119_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000105417397147025396920000013417194146742955710_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011006664117532373410000005930573706429240230_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105417397147025396920000013417194146742955710_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 98.7,
    y: 36.4,
    style: {
      clipPath: "url(#SVGID_00000011006664117532373410000005930573706429240230_)",
      fill: "#808080"
    },
    width: 21.7,
    height: 4.5
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000104671435813149010300000001899198530444623249_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015338183508777491210000008075233657358705301_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104671435813149010300000001899198530444623249_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015338183508777491210000008075233657358705301_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000048468550944260129660000012800510929311826864_",
    d: "M100.3,39.1c3.1-0.5,6.3-0.8,9.5-0.8 c3,0,6,0.2,8.9,0.7v0.2c-2.9-0.5-5.9-0.7-8.9-0.7c-3.2,0-6.4,0.3-9.5,0.8V39.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071531533169413191130000010604751237742989502_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048468550944260129660000012800510929311826864_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000071531533169413191130000010604751237742989502_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008126560947422131350000001205807833989919662_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047053062204845019860000007067511808689984690_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008126560947422131350000001205807833989919662_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 37.3,
    style: {
      clipPath: "url(#SVGID_00000047053062204845019860000007067511808689984690_)",
      fill: "#808080"
    },
    width: 20.4,
    height: 3
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158005010156212116740000008693963201972183205_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095298202458868813590000013030278041201460154_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158005010156212116740000008693963201972183205_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095298202458868813590000013030278041201460154_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000113321927031125783410000012304671169617435564_",
    d: "M91.7,42.1l-0.4-1.2 c-15.7,5.6-28.4,18.3-33.8,34l1.2,0.4C64,59.9,76.3,47.5,91.7,42.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075862163726570129210000013373499725069949602_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113321927031125783410000012304671169617435564_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075862163726570129210000013373499725069949602_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000063620889621530554800000008873956773377002376_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155105278821655964310000010061094080509616305_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063620889621530554800000008873956773377002376_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 39.9,
    style: {
      clipPath: "url(#SVGID_00000155105278821655964310000010061094080509616305_)",
      fill: "#808080"
    },
    width: 36.2,
    height: 36.5
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000059295548691391377520000006848335525087891861_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092418531150597266290000007004921216420102318_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059295548691391377520000006848335525087891861_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092418531150597266290000007004921216420102318_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000045583551580267493560000003797986798586759608_",
    d: "M58.2,74.6c5.4-15.2,17.6-27.5,32.8-33l0.1,0.2 C76,47.3,63.8,59.6,58.4,74.7L58.2,74.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182496635537105565920000001348095748953157539_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045583551580267493560000003797986798586759608_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182496635537105565920000001348095748953157539_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000156574925701798826900000016644259142945507978_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029029617053320101920000012991070196975795117_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156574925701798826900000016644259142945507978_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 40.6,
    style: {
      clipPath: "url(#SVGID_00000029029617053320101920000012991070196975795117_)",
      fill: "#808080"
    },
    width: 34.9,
    height: 35.1
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026122833079386076040000016705346471800514481_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103249319902380850740000005622167489964001414_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026122833079386076040000016705346471800514481_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103249319902380850740000005622167489964001414_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000177451113779849471350000000401803528101330082_",
    d: "M54.9,86.1c-0.3,2.3-0.4,4.6-0.4,6.9 c0,4.4,0.5,8.7,1.5,12.9l1.2-0.3c-1-4.1-1.5-8.4-1.5-12.6c0-2.3,0.1-4.5,0.4-6.8L54.9,86.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128482490985869192350000015680690067722192779_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177451113779849471350000000401803528101330082_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000128482490985869192350000015680690067722192779_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058564547279441440520000012530579303738242967_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157987086600343426240000017083339347050043572_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058564547279441440520000012530579303738242967_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 85.1,
    style: {
      clipPath: "url(#SVGID_00000157987086600343426240000017083339347050043572_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.9
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002360982799045204580000017385102285606579381_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177463713402373833790000014057820926562577565_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002360982799045204580000017385102285606579381_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000177463713402373833790000014057820926562577565_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000069359081808456165190000003955242664780971398_",
    d: "M56.4,105.3c-0.9-4-1.4-8.1-1.4-12.3 c0-2.1,0.1-4.3,0.4-6.3h0.2c-0.2,2.1-0.4,4.2-0.4,6.3c0,4.1,0.5,8.3,1.4,12.2L56.4,105.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125593525920871799250000008219072413122179736_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069359081808456165190000003955242664780971398_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000125593525920871799250000008219072413122179736_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044137785882266314260000007284326109434917308_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183242301952777972510000017360234069112748419_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044137785882266314260000007284326109434917308_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 85.6,
    style: {
      clipPath: "url(#SVGID_00000183242301952777972510000017360234069112748419_)",
      fill: "#808080"
    },
    width: 3.6,
    height: 20.6
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114060490387254806380000007232544130902598787_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063609228677942699210000003429129323830124461_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114060490387254806380000007232544130902598787_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000063609228677942699210000003429129323830124461_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000006668892498808917130000010541082746680723349_",
    d: "M90,144.7l0.5-1.2c-13-5-23.9-15.1-29.8-27.8 l-1.1,0.5C65.6,129.2,76.7,139.6,90,144.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160892688153959230430000000239331711661608853_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006668892498808917130000010541082746680723349_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160892688153959230430000000239331711661608853_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178886181511322003690000015403586238863753091_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155116233584736017660000015941123379435441552_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178886181511322003690000015403586238863753091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 114.7,
    style: {
      clipPath: "url(#SVGID_00000155116233584736017660000015941123379435441552_)",
      fill: "#808080"
    },
    width: 32.9,
    height: 30.9
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021834171041946558510000000862726169259278247_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008142750407374921360000006528604126537866126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021834171041946558510000000862726169259278247_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000008142750407374921360000006528604126537866126_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000057136366041768345510000006560717945448853894_",
    d: "M89.7,144c-12.8-5-23.5-15-29.4-27.5l0.2-0.1 c5.9,12.4,16.6,22.3,29.3,27.4L89.7,144z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147930061475413900580000006873132033468283288_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057136366041768345510000006560717945448853894_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147930061475413900580000006873132033468283288_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021092416882884728050000002380184899911671175_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081628541676883498250000015049234859682113181_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021092416882884728050000002380184899911671175_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 115.4,
    style: {
      clipPath: "url(#SVGID_00000081628541676883498250000015049234859682113181_)",
      fill: "#808080"
    },
    width: 31.5,
    height: 29.5
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005265639638053978440000006205187858656734596_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013173664512339908970000015600504406394134445_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005265639638053978440000006205187858656734596_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013173664512339908970000015600504406394134445_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042017438621799661970000013184475410109863838_",
    d: "M128,40.9l-0.4,1.2c15.4,5.4,27.7,17.9,33,33.3 l1.2-0.4C156.4,59.2,143.7,46.4,128,40.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036213658787554879270000012733214733907412624_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042017438621799661970000013184475410109863838_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036213658787554879270000012733214733907412624_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068657550019152971310000015253367489680405414_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170993927290003440490000007970491829692439486_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068657550019152971310000015253367489680405414_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 126.6,
    y: 39.9,
    style: {
      clipPath: "url(#SVGID_00000170993927290003440490000007970491829692439486_)",
      fill: "#808080"
    },
    width: 36.2,
    height: 36.5
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098212604490432517250000000353212085454072497_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005265927915481762370000004932779832023893419_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098212604490432517250000000353212085454072497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005265927915481762370000004932779832023893419_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009577498743296477110000005582581011347859894_",
    d: "M161,74.7c-5.4-15.1-17.6-27.4-32.7-32.9 l0.1-0.2c15.2,5.5,27.4,17.8,32.8,33L161,74.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122715825748961172320000013601364385774016165_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009577498743296477110000005582581011347859894_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122715825748961172320000013601364385774016165_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065046389828253348900000009589547681139924912_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057122395678267946040000009795171967210453674_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065046389828253348900000009589547681139924912_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 127.3,
    y: 40.6,
    style: {
      clipPath: "url(#SVGID_00000057122395678267946040000009795171967210453674_)",
      fill: "#808080"
    },
    width: 34.9,
    height: 35.1
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021089022301153974640000008271766343501226676_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008828166789783125540000010080910462163748233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021089022301153974640000008271766343501226676_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000008828166789783125540000010080910462163748233_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000060005186677631895630000007580620679790730384_",
    d: "M163.3,105.9c1-4.2,1.5-8.6,1.5-12.9 c0-2.3-0.1-4.7-0.4-6.9l-1.2,0.2c0.3,2.2,0.4,4.5,0.4,6.8c0,4.3-0.5,8.5-1.5,12.6L163.3,105.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047022437159680005120000010282562422009811390_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060005186677631895630000007580620679790730384_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047022437159680005120000010282562422009811390_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119100373492384336030000000444355436218416783_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178899035848622795850000004734700516863668665_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119100373492384336030000000444355436218416783_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.1,
    y: 85.1,
    style: {
      clipPath: "url(#SVGID_00000178899035848622795850000004734700516863668665_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.9
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000037681771129844364070000002513406290828101773_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016762887070391898680000013294815502630429061_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037681771129844364070000002513406290828101773_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016762887070391898680000013294815502630429061_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000014599572586796702920000017625179487060620977_",
    d: "M162.7,105.2c0.9-4,1.4-8.1,1.4-12.2 c0-2.1-0.1-4.2-0.4-6.3h0.2c0.2,2.1,0.4,4.2,0.4,6.3c0,4.1-0.5,8.3-1.4,12.3L162.7,105.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142142276031212910610000016385921088664809891_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014599572586796702920000017625179487060620977_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142142276031212910610000016385921088664809891_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026165282383703729800000003538293654422310331_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029022552137778355360000001558024995394578560_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026165282383703729800000003538293654422310331_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.7,
    y: 85.6,
    style: {
      clipPath: "url(#SVGID_00000029022552137778355360000001558024995394578560_)",
      fill: "#808080"
    },
    width: 3.6,
    height: 20.6
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036971554007780331850000011529763239329970305_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040533221216498725090000003335700630939372978_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036971554007780331850000011529763239329970305_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000040533221216498725090000003335700630939372978_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000036249951529386758440000010714004461066656952_",
    d: "M128.8,143.5l0.5,1.2 c13.3-5.1,24.4-15.4,30.4-28.4l-1.1-0.5C152.7,128.4,141.9,138.5,128.8,143.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048502465922573704220000008925728474833690557_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036249951529386758440000010714004461066656952_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000048502465922573704220000008925728474833690557_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080172294469373115850000016195241383703504288_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019648500409045377390000001987969736257835682_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080172294469373115850000016195241383703504288_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 127.8,
    y: 114.7,
    style: {
      clipPath: "url(#SVGID_00000019648500409045377390000001987969736257835682_)",
      fill: "#808080"
    },
    width: 32.9,
    height: 30.9
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000167398561411947481490000013196431280662543242_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004523671506168932430000012206662893114737026_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167398561411947481490000013196431280662543242_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004523671506168932430000012206662893114737026_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000035517563637458647070000001252898016420026788_",
    d: "M129.5,143.8c12.8-5,23.4-15,29.3-27.4l0.2,0.1 c-5.9,12.4-16.6,22.4-29.4,27.5L129.5,143.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032612735729454356540000018116515167407273642_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035517563637458647070000001252898016420026788_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032612735729454356540000018116515167407273642_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114053002639358654470000003476514984751843204_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127019301052785146390000009838313634996559758_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114053002639358654470000003476514984751843204_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 115.4,
    style: {
      clipPath: "url(#SVGID_00000127019301052785146390000009838313634996559758_)",
      fill: "#808080"
    },
    width: 31.5,
    height: 29.5
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000045598962207372057530000012837726609187179143_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083807845039701585270000008273286968132398009_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045598962207372057530000012837726609187179143_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083807845039701585270000008273286968132398009_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054981204817794291590000014548326748526587542_",
    d: "M118.1,147.7l-0.2-1.2 c-5.5,0.8-11.2,0.8-16.7-0.1l-0.2,1.2c2.9,0.5,5.9,0.7,8.8,0.7C112.5,148.3,115.3,148.1,118.1,147.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095321061406343719970000008577327850259269281_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054981204817794291590000014548326748526587542_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095321061406343719970000008577327850259269281_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000020388761040566191780000006999693016248693133_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008116417520380432670000001291381741430867335_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020388761040566191780000006999693016248693133_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 145.3,
    style: {
      clipPath: "url(#SVGID_00000008116417520380432670000001291381741430867335_)",
      fill: "#808080"
    },
    width: 19.1,
    height: 3.9
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114041681826634303350000009308749017786507174_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179641001048951416020000002564277669482994868_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114041681826634303350000009308749017786507174_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000179641001048951416020000002564277669482994868_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000022536147820275797180000003368290086211029651_",
    d: "M109.8,147.7c-2.8,0-5.5-0.2-8.2-0.6v-0.2 c2.7,0.4,5.4,0.6,8.2,0.6c2.6,0,5.1-0.2,7.6-0.5v0.2C114.9,147.6,112.3,147.7,109.8,147.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109722321534236374970000006988384396686325643_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022536147820275797180000003368290086211029651_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109722321534236374970000006988384396686325643_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067924815279591567370000007114699175178610823_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159463951395653731070000008985953304835152312_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067924815279591567370000007114699175178610823_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 145.9,
    style: {
      clipPath: "url(#SVGID_00000159463951395653731070000008985953304835152312_)",
      fill: "#808080"
    },
    width: 17.9,
    height: 2.8
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083070776654928383310000002426269189388929156_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013893517062660444540000016771924021017258121_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083070776654928383310000002426269189388929156_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013893517062660444540000016771924021017258121_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs116 || (_defs116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000167384168934278976130000001435431163151758976_",
    cx: 39.8,
    cy: 157.5,
    r: 17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155137596488247345670000004969096913464427905_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167384168934278976130000001435431163151758976_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155137596488247345670000004969096913464427905_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs117 || (_defs117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080190284256090748310000006930248972726235538_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026844500673836475180000017183679070493906830_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080190284256090748310000006930248972726235538_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000026844500673836475180000017183679070493906830_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 3.2748,
      strokeMiterlimit: 10
    },
    cx: 39.8,
    cy: 157.5,
    rx: 17,
    ry: 17
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs118 || (_defs118 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021095158751926593580000013680765816832335240_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161590614969685083480000010664042166554937500_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021095158751926593580000013680765816832335240_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000161590614969685083480000010664042166554937500_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs119 || (_defs119 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000073709139658484984430000001895617291466879650_",
    d: "M37.9,28.4c0,9.4,7.6,17,17,17s17-7.6,17-17 s-7.6-16.9-17-16.9C45.5,11.5,37.9,19.1,37.9,28.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153689756857966704290000018154545204240450191_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073709139658484984430000001895617291466879650_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000153689756857966704290000018154545204240450191_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs120 || (_defs120 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155143639329795199410000015108315138874686868_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068658368466352304650000013217266015730427779_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155143639329795199410000015108315138874686868_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000068658368466352304650000013217266015730427779_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 3.2748,
      strokeMiterlimit: 10
    },
    cx: 54.9,
    cy: 28.4,
    rx: 17,
    ry: 17
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs121 || (_defs121 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000064323816083344490130000016532935665026204087_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106138405195910096490000013232755523432296101_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064323816083344490130000016532935665026204087_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106138405195910096490000013232755523432296101_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs122 || (_defs122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106866497156674989720000014511206571839430784_",
    d: "M11.9,112.6c0,9.4,7.6,17,17,17s17-7.6,17-17 s-7.6-17-17-17C19.5,95.7,11.9,103.2,11.9,112.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046335503795995286940000016093495235152952461_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106866497156674989720000014511206571839430784_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000046335503795995286940000016093495235152952461_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs123 || (_defs123 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132085924372838687150000001399540248389752225_",
    x: 1.9,
    y: 1.5,
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175293273824882695900000016586106906695399556_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132085924372838687150000001399540248389752225_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000175293273824882695900000016586106906695399556_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 3.2748,
      strokeMiterlimit: 10
    },
    cx: 28.9,
    cy: 112.6,
    rx: 17,
    ry: 17
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs124 || (_defs124 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158710554396988708760000013388057014883207599_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111178584815600992350000015794233786626340503_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158710554396988708760000013388057014883207599_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111178584815600992350000015794233786626340503_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs125 || (_defs125 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000077322308087295513760000014022421496056588460_",
    cx: 36,
    cy: 75.1,
    r: 17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111887528870985351600000016183789023814799284_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077322308087295513760000014022421496056588460_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111887528870985351600000016183789023814799284_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs126 || (_defs126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031189332737071667610000009156470374464616884_",
    x: -34.04,
    y: -76.6,
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 39.0059 75.6581)",
    width: 196,
    height: 183
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138575424482524934510000003586025493055793798_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031189332737071667610000009156470374464616884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000138575424482524934510000003586025493055793798_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 3.2748,
      strokeMiterlimit: 10.0002
    },
    cx: 36,
    cy: 75.1,
    rx: 17,
    ry: 17
  })))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs127 || (_defs127 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054232240597983736120000008248223118925917578_",
    x: 11.9,
    y: 10.5,
    width: 176,
    height: 164
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147199857913189632480000016027111690380624795_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054232240597983736120000008248223118925917578_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147199857913189632480000016027111690380624795_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs128 || (_defs128 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000134945705518864381570000014437723179917788049_",
    d: "M109.2,75.2v43.7c-7.3-5.4-15-11.5-16-21V79.1 c2,1,4.2,1,6.4,1C103.4,80.2,106.8,78,109.2,75.2z M109.8,72.1c-0.2,0-0.4,0.2-0.5,0.4c-2,3.3-5.8,6.1-9.7,6.1 c-2.7,0-4.9,0-6.7-1.5c-0.5-0.4-1.3,0-1.3,0.7v20.3c1,10.9,10.2,17.5,17.9,23.2c0.3,0.2,0.7,0.2,0.9,0 c7.7-5.7,16.9-12.2,17.9-23.2v-8.2c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8V98c-0.9,9.5-8.6,15.6-16,21V75.3 c2.4,2.8,5.8,5,9.6,5c2.2,0,4.4-0.1,6.4-1v5.9c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-7.3c0-0.6-0.8-1-1.3-0.7 c-1.8,1.4-4,1.5-6.7,1.5c-3.9,0-7.7-2.8-9.7-6.1C110.5,72.4,110.2,72.2,109.8,72.1C109.9,72.1,109.9,72.1,109.8,72.1z  M110,64.4c3.4,4.6,9.2,6.9,15.2,6.9c3.6,0,6.8-0.8,9.6-2.6v29.1c-1.4,13.9-13.7,22.8-24.7,30.6 c-11.1-7.8-23.4-16.6-24.7-30.6V68.7c2.8,1.8,6,2.6,9.6,2.6C100.8,71.3,106.5,69,110,64.4z M109.8,62.4 c-0.2,0-0.4,0.2-0.5,0.3c-3,4.6-8.5,6.9-14.5,6.9c-3.8,0-7.1-0.9-9.9-3.1c-0.5-0.4-1.3,0.1-1.3,0.7v30.7 c1.5,15,14.7,24.2,25.9,32.1c0.3,0.2,0.6,0.2,0.9,0c11.2-7.9,24.4-17,25.9-32.1V67.2c0-0.6-0.8-1-1.3-0.7 c-2.8,2.1-6.1,3.1-9.9,3.1c-5.9,0-11.5-2.3-14.5-6.9c-0.1-0.2-0.4-0.4-0.7-0.4C109.9,62.4,109.9,62.4,109.8,62.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098936213457650131480000016177285187973964949_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134945705518864381570000014437723179917788049_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098936213457650131480000016177285187973964949_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs129 || (_defs129 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000091729897194407610570000006045812964754982808_",
    x: 82.6,
    y: 61.3,
    width: 54.7,
    height: 69.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167398288545117799590000003405580742270972844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091729897194407610570000006045812964754982808_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82.6,
    y: 61.4,
    style: {
      opacity: 0.58,
      clipPath: "url(#SVGID_00000167398288545117799590000003405580742270972844_)",
      fill: "#808080"
    },
    width: 54.7,
    height: 69.9
  })))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnsShield);
export default __webpack_public_path__ + "static/media/vulns-shield.218a6068902cb916154833fda8bad72d.svg";
export { ForwardRef as ReactComponent };